var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.node_a in _vm.badges)?[_vm._v("\n    "+_vm._s(_vm.node_a)+"\n    "),_c('img',{staticClass:"align-middle inline-block",attrs:{"src":_vm.badges[_vm.node_a],"alt":_vm.badges[_vm.node_a]['title']}})]:[_vm._v("\n    "+_vm._s(_vm.node_a)+"\n  ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }